import React from 'react';
import { Link } from 'react-router-dom';
import "../../styles.css";

const letters = [
    'SMT',
    'PNC',
    'KRB',
    'JFG',
    'HDW',
    'VLY'
];

function SubLevelSelectButton(props) {
    return (
        <div className='levelSelectButtonText'>
            <Link to={'/level' + props.level} className='levelSelectButton' style={{ textDecoration: 'none' }}>{props.number}</Link>
        </div>
    );
}

export default SubLevelSelectButton;